export const SIZE = {
  default: "default",
  compact: "compact",
  large: "large",
};
